import { Component, OnInit} from '@angular/core';
import { SubmissionSearchObject, SubmissionSearchUserInfoObject } from '../search-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {DateUtil} from '../date-util';
import * as _moment from 'moment';
import {PaginationObject} from '../pagination-object';

declare var $: any;

const moment = _moment;

@Component({
    selector: 'submission-search',
    templateUrl: './submission-search.component.html',
    styleUrls: [ './submission-search.component.scss' ],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: DateUtil.MY_FORMATS}
      ]
})
export class SubmissionSearchComponent implements OnInit {

    date = new FormControl(moment());
    minDate = new Date(2000, 0, 1);
    maxDate = new Date();
    searchCriteria = new SubmissionSearchObject();
    userSearchInfo = new SubmissionSearchUserInfoObject();
    pagination: PaginationObject = new PaginationObject();

    ngOnInit() {
        this.submissionHistoryService.currentUserInfo.subscribe(message => this.userSearchInfo = message);
        this.submissionHistoryService.currentPagination.subscribe(message => this.pagination = message);
        this.submissionHistoryService.currentSearchCriteria.subscribe(message => this.searchCriteria = message);
    }

    constructor(private submissionHistoryService: SubmissionHistoryService) {
        this.searchCriteria.submissionIdentifierType = 'hml';
    }

    onSubmit() {
        if (DateUtil.validateDateTime($( '#startDate' )[0].value) && DateUtil.validateDateTime($( '#endDate' )[0].value)) {
            this.updateTableDataSearch(this.searchCriteria);
            this.getTotalCountSearch(this.searchCriteria);
        } else {
            return;
        }
    }

    public updateTableDataSearch(search: SubmissionSearchObject): void {
        const startDateTime = $( '#startDate' )[0].value + ' ' + $( '#startTime' )[0].value;
        const endDateTime = $( '#endDate' )[0].value + ' ' + $( '#endTime' )[0].value;
        this.pagination.currentPage = 0;
        this.submissionHistoryService.changePagination(this.pagination);
        this.submissionHistoryService.getSearchTableContent(search, startDateTime.trim(), endDateTime.trim(), 0);
        $('#dashboardScrollPane').scrollTop(0);
    }

    public getTotalCountSearch(search: SubmissionSearchObject): void {
        const startDateTime = $( '#startDate' )[0].value + ' ' + $( '#startTime' )[0].value;
        const endDateTime = $( '#endDate' )[0].value + ' ' + $( '#endTime' )[0].value;
        this.submissionHistoryService.getSearchTableContentCount(search, startDateTime.trim(), endDateTime.trim());
    }

    clear() {
        this.searchCriteria = new SubmissionSearchObject();
        $('input[type=time]').val('');
        this.searchCriteria.submissionIdentifierType = 'hml';
    }

    public onStartDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            $( '#startDateFormField' ).removeClass( 'mat-form-field-invalid' )
        } else {
            $( '#startDateFormField' ).addClass( 'mat-form-field-invalid' )
        }
    }


    public onEndDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            $( '#endDateFormField' ).removeClass( 'mat-form-field-invalid' )
        } else {
            $( '#endDateFormField' ).addClass( 'mat-form-field-invalid' )
        }
    }

    public onStartDateSelected() {
        $( '#startDateFormField' ).removeClass( 'mat-form-field-invalid' )
    }

    public onEndDateSelected() {
        $( '#endDateFormField' ).removeClass( 'mat-form-field-invalid' )
    }
}
